import { Component, Prop, State, Event, EventEmitter, Watch, h } from '@stencil/core';
import { isRtl } from '@ugc-utils/utils';
import { Search, CloseFill } from '../../icons/index';

@Component({
  tag: 'ugc-input',
  styleUrl: 'ugc-input.scss',
  shadow: false,
})
export class UgcInput {
  @Prop() inputName: string = '';
  @Prop() inputValue: string = '';
  @Prop() isShowSearchIcon: boolean = false;
  @Prop() width: string = '';
  @Prop() isNeedPadding: boolean = true;

  @State() value: string = '';
  @State() isOpen: boolean = false;

  @Event() inputChange: EventEmitter;

  inputElement!: HTMLInputElement;

  componentWillLoad() {
    this.value = this.inputValue;
  }

  @Watch('inputValue')
  watchInputValue(newValue) {
    this.value = newValue;
  }

  handleInputClick() {
    this.isOpen = true;
  }
  handleInputBlur() {
    this.isOpen = false;
  }

  handleInput({ target: { value = '' } }) {
    this.value = value;
    this.inputChange.emit(value);
  }

  handleClear() {
    this.value = '';
    this.isOpen = false;
    this.inputChange.emit('');
  }

  render() {
    const inputStyle = this.isNeedPadding
      ? isRtl()
        ? { padding: `0 16px 0 48px` }
        : { padding: `0 48px 0 16px` }
      : { padding: '0 14px' };
    const inputWrapStyle: any = {};
    if (this.width !== '') {
      inputWrapStyle.width = this.width;
    }

    const renderSearchIcon = this.isShowSearchIcon && (
      <div class="search-button flex-row-center-center">
        <Search width="24" height="24" />
      </div>
    );
    const renderCloseButton = this.isShowSearchIcon && (
      <div class="close-button flex-row-center-center" onClick={this.handleClear.bind(this)}>
        <CloseFill width="24" height="24" />
      </div>
    );

    return (
      <div
        class={{ 'ugc-input-wrap': true, 'flex-row-between-center': true, 'input-active': this.isOpen }}
        style={inputWrapStyle}
      >
        <input
          type="text"
          ref={el => (this.inputElement = el as HTMLInputElement)}
          id={this.inputName}
          class="pointer"
          style={inputStyle}
          value={this.value}
          onInput={this.handleInput.bind(this)}
          onClick={this.handleInputClick.bind(this)}
          onBlur={this.handleInputBlur.bind(this)}
          autocomplete="off"
        />
        <label htmlFor={this.inputName} class={{ pointer: true, 'label-active': this.value !== '' }}>
          {this.inputName}
        </label>

        {this.value === '' ? renderSearchIcon : renderCloseButton}
      </div>
    );
  }
}
